import React from "react";

function Register(props: any) {
	const { onPress } = props;

	return <button>hola</button>;
}

export default Register;
